var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-row', {
    staticClass: "ma-n2 ma-lg-n4"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', _vm._b({
      key: item.value,
      staticClass: "pa-2 pa-lg-4",
      attrs: {
        "cols": "6"
      }
    }, 'v-col', {
      lg: _vm.lg
    }, false), [_c('v-responsive', {
      staticStyle: {
        "overflow": "visible"
      },
      attrs: {
        "aspect-ratio": _vm.$vuetify.breakpoint.mobile ? 3 / 2 : 3 / 1
      }
    }, [_c('v-card', _vm._b({
      staticClass: "fill-height",
      staticStyle: {
        "overflow": "visible",
        "pointer-events": "none"
      },
      attrs: {
        "elevation": "0"
      },
      on: {
        "!click": function click($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.go(item);
        }
      }
    }, 'v-card', {
      disabled: item.disabled || _vm.loading,
      to: "/exchange/".concat(item.value.toLowerCase())
    }, false), [_c('v-card', _vm._b({
      attrs: {
        "rounded": ""
      }
    }, 'v-card', {
      elevation: item.active ? 0 : undefined,
      outlined: item.active,
      class: {
        'exchange-codes__card': true,
        'exchange-codes__card--active': item.active,
        'fill-height': true
      }
    }, false), [_c('v-card-text', {
      staticClass: "fill-height d-flex justify-center align-center px-4 py-0"
    }, [_c('v-img', _vm._b({}, 'v-img', Object.assign({}, item.image, {
      contain: true
    }), false))], 1)], 1)], 1)], 1)], 1)];
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }